import { LoadingIcon } from "./Icons"

const PageLoading = () => {
  return (
    <div className="flex justify-center pt-[100px]">
      <LoadingIcon size="3x" />
    </div>
  )
}

export default PageLoading
